module.exports = __webpack_public_path__ + "images/f5d277d7ba0d9868664caa1984af3251.png";